/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { FieldSet, FieldSetComponent } from '@src/app/shared/form/field-set/field-set.component';
import { MatButtonModule } from '@angular/material/button';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { ErrorHelper } from '@src/app/shared/form/form-error/form-error.component';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AbstractObject } from '@src/app/model/abstract-object';

export class FieldSetDialogOptions {
    fieldSet: FieldSet;
    saveText?: string;
    saveFn: (unknown) => Observable<AbstractObject>;
    cancelValue?: unknown;
    title: string;
    minHeight?: string;
    minWidth?: string;
}

@Component({
    selector: 'app-field-set-dialog',
    templateUrl: './field-set-dialog.component.html',
    styleUrls: ['./field-set-dialog.component.scss'],
    imports: [MatDialogContent, MatButtonModule, DialogBannerComponent, FieldSetComponent]
})
export class FieldSetDialogComponent {
    cds = inject(ConfirmDialogService);
    dialogRef = inject(MatDialogRef);
    dialogOptions = inject(MAT_DIALOG_DATA) as FieldSetDialogOptions;

    saveText = $localize `Save`
    saving = false;

    constructor() {
        if (this.dialogOptions.saveText) {
            this.saveText = this.dialogOptions.saveText;
        }
        console.log('Created Dialog', this);
    }

    cancel() {
        this.dialogRef.close(this.dialogOptions.cancelValue ?? null);
    }

    save() {
        if (this.dialogOptions.fieldSet.formGroup.valid) {
            this.saving = true;
            this.dialogOptions.saveFn(this.dialogOptions.fieldSet.getFormValue()).subscribe ( x => {
                this.dialogRef.close(x);
            })
        } else {
            let errs = '';
            this.dialogOptions.fieldSet.fields.forEach ( f => {
                if (!f.control.valid) {
                    errs += f.name + ': [' + ErrorHelper.getAllMsgs(f.control as UntypedFormControl) + '] ';
                }
            })
            this.cds.alert('Correct Errors Before you can save', errs);
        }
    }
}
